export const FONT_ICON_FORMAT = {
    ICON: 'icon',
    FONT: 'font'
};

export const FONT_ICON_SVG_FALLBACK = 'https://stage.cdn1.parksmedia.wdprapps.disney.com';
